import Vue from 'vue'
import Vuex from 'vuex'
import {SET_USER,SET_HISTORY_KEYWORDS,SET_INS_ID,SET_DOMAIN_MAP } from './types'
import {BaseUtil} from '@zkwq/business'
import {CACHE_KEY} from '../constants'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    user:BaseUtil.getStorage(CACHE_KEY.USER),
    insId:BaseUtil.getStorage(CACHE_KEY.INS_ID),
    domain:BaseUtil.getStorage(CACHE_KEY.DOMAIN),
    domainMap:null,
    historyKeywords:null,
  },
  mutations: {
    [SET_USER](state,user){
      state.user = user
    },
    [SET_HISTORY_KEYWORDS] (state, historyKeywords) {
      state.historyKeywords = historyKeywords
    },
    [SET_INS_ID] (state, {insId,domain}) {
      BaseUtil.setStorage(CACHE_KEY.INS_ID,insId)
      BaseUtil.setStorage(CACHE_KEY.DOMAIN,domain)
      state.insId = insId
      state.domain = domain
    },
    [SET_DOMAIN_MAP](state,domainMap){
      state.domainMap = domainMap;
    }
  },
  actions: {
    [SET_HISTORY_KEYWORDS] ({ commit }, historyKeywords) {
      commit(SET_HISTORY_KEYWORDS, historyKeywords)
    }
  },
  modules: {
  }
})
